import React, {useMemo} from 'react';
import {useTranslation} from "react-i18next";

import TableContainer from '../Communications/Table/TableContainer';
import DateFormated from "../../../Utils/Date/Date";
import Alert from "../../../UI/Alerts/Alert";
import BasicDataTable from "../../../Utils/BasicDataTable";

const OrderDetails = (props) => {
    const { t, i18n } = useTranslation();
    const { subaccount, order} = props;

    const descAccessor = ((i18n.language === 'fr') ? 'descriptionFr' : 'descriptionEn');

    const columns = useMemo(
        () => [
            {
                Header: t('orders.details.table.headers.productnumber'),
                accessor: 'productCode.code',
                Cell: (props) => {
                    return (props.value) ? props.value : '';
                },
            },
            {
                Header: t('orders.details.table.headers.product'),
                accessor: 'productCode.'+descAccessor,
                Cell: (props) => {
                    return (props.value) ? props.value : '';
                },
            },
            {
                Header: t('orders.details.table.headers.quantity'),
                accessor: 'requestedQuantity',
                Cell: (props) => {

                    // Si Status livré ou si c'est de l'empaqueté on affiche quantité livré
                    if (order.statusCode.code === "L" || order.deliveryMode.code === "E") {
                        return (props.row.original.shippedQuantity != null)?parseFloat(props.row.original.shippedQuantity).toFixed(2):"";
                    }

                    // si status C ou P pour un compte compteur et que c'est un plein on affiche 'plein'
                    if ((order.statusCode.code === "C" || order.statusCode.code === "P")
                        && order.deliveryMode.code === "C"
                        && props.row.original.isNotFull === false) {
                           return t('popuporder.full');
                    }
                    // sinon quantité demandé
                    return (props.value != null)?parseFloat(props.value).toFixed(2):"";
                },
            },
        ],
        [t, i18n, order.lines]
    );

    return (
        <div className="order__details">
            <div className="row row--rmline">
                <div className="col-12 col-md-6 order__details__left">
                    <div className="order__subaccount subaccount modal__content__block">
                        <p>
                            <strong className="subaccount__name">{subaccount.subAccountCode} - {subaccount.subAccountName}</strong><br/>
                            {(subaccount.address.addressLine1) && <span className="subaccount__address1">{subaccount.address.addressLine1}<br/></span>}
                            {(subaccount.address.addressLine2) && <span className="subaccount__address2">{subaccount.address.addressLine2}<br/></span>}
                            {(subaccount.address.city) && <span className="subaccount__city">{subaccount.address.city}<br/></span>}
                            {(subaccount.address.postalCode) && <span className="subaccount__postal-code">{subaccount.address.postalCode}</span>}
                        </p>
                    </div>
                    <div className="order__notes modal__content__block">
                        <p>
                            <strong>{t('orders.details.instructions')}</strong><br/>
                            {(order.printedNotes) ? order.printedNotes : ''}
                        </p>
                    </div>
                    <div className="order__status modal__content__block">
                        {
                            !(order.orderStatus.code === "C" || order.orderStatus.code === "U" || order.statusCode.code === "L") &&
                            <Alert type="success" item={{
                                type: 'success',
                                additionalClasses: 'message--condensed message--delivery',
                                customIcon: 'fas fa-shipping-fast',
                                text: t('orders.shipping_notice')
                            }}/>
                        }
                    </div>
                </div>
                <div className="col-12 col-md-4 offset-md-2 order__details__right">
                    <div className="modal__content__block">
                        <p className="order__date">
                            <strong>{t('orders.details.date')} <DateFormated date={order.orderDate}/><br/></strong>
                        </p>
                    </div>
                    <div className="modal__content__block">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="order__data">
                                    <strong>{t('orders.details.deliverynumber')}</strong><br/>
                                    {order.deliveryNumber}
                                </p>
                            </div>
                            {/*
                                <div className="col-md-6">
                                <p className="order__data">
                                    <strong>{t('orders.details.weight')}</strong><br/>
                                    !!!MISSING DATA VALUE!!!
                                </p>
                            </div>
                                 */}
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <p className="order__data">
                                    <strong>{t('orders.details.ordernumber')}</strong><br/>
                                    {order.poNumber}
                                </p>
                            </div>
                            <div className="col-md-6">
                                <p className="order__data">
                                    <strong>{t('orders.details.pallets')}</strong><br/>
                                    {parseFloat(order.palletCount).toFixed(2)}
                                </p>
                            </div>
                        </div>
                        {order.deliveryDate != null && <div className="row">
                            <div className="col-12">
                                <p className="order__data">
                                    <strong>{(i18n.language === 'fr')?order.deliveryDateLabel.descriptionFr:order.deliveryDateLabel.descriptionEn}</strong><br/>
                                    <DateFormated date={order.deliveryDate}/>
                                </p>
                            </div>
                        </div> }
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="modal__content__block">
                        <BasicDataTable columns={columns} data={order.lines} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderDetails;
